import { defaultFormatter } from "util/object";
import { sortByLabelAsc } from "util/sort-by-prop";

function arrayToSelectOptions(arr) {
  return arr
    .filter((value) => value)
    .map((value) => {
      return { label: value, value };
    })
    .sort(sortByLabelAsc);
}

function getBooleanOptions() {
  return [
    { label: "True", value: true },
    { label: "False", value: false },
  ];
}

/*
 * Find a select option from an array of options. If the option is not
 * found return the value as the option.
 *
 * @param options Array of select options.
 * @param value Select option value.
 * @returns {{label: *, value: *}} A Select Object.
 */
function getOpt(options, value) {
  // In case options is null.
  const opt = (options || []).find((o) => o.value === value);
  if (opt) {
    return opt;
  }

  return {
    label: value,
    value,
  };
}

function getSelectedOpts(options, values) {
  const boundGetOpt = getOpt.bind(null, options || []);

  return (values || []).map(boundGetOpt).sort(sortByLabelAsc);
}

function modelsToSelectOptions(models, formatter = defaultFormatter) {
  return Object.values(models)
    .map((model) => ({ value: model.id, label: formatter(model) }))
    .sort(sortByLabelAsc);
}

// Select menu fix.
const STYLES = {
  menu: (s) => ({ ...s, zIndex: 100 }),
};

export {
  arrayToSelectOptions,
  getBooleanOptions,
  getOpt,
  getSelectedOpts,
  modelsToSelectOptions,
  STYLES,
};
